import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const INPUT_STYLE = { display: 'none' };

export default function UploadFormHandler({
  handleFiles,
  multiple,
  accept,
  children,
}) {
  const $input = useRef();

  const handleFileInput = (e) => handleFiles(e.target.files);

  const handleClick = (e) => {
    e.preventDefault();

    $input.current.click();
  };

  return (
    <>
      <input
        ref={$input}
        type="file"
        multiple={multiple}
        accept={accept}
        style={INPUT_STYLE}
        onChange={handleFileInput}
        onClick={(event) => {
          event.currentTarget.value = null;
        }}
      />
      {children(handleClick)}
    </>
  );
}

UploadFormHandler.propTypes = {
  accept: PropTypes.string.isRequired,
  handleFiles: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  children: PropTypes.func.isRequired,
};
